<div class="flex flex-col gap-3">
  <p-datepicker [ngModel]="date()" (ngModelChange)="onChange($event)" [inline]="true" [showWeek]="true"></p-datepicker>
</div>

<ng-template #loading>
  <div class="px-3">
    <p-skeleton width="100%" height="54px"></p-skeleton>
  </div>
</ng-template>
